import { useRootCategoriesQuery } from '@/graphql/generated/hooks'
import { AdPetType, CategoryType } from '@/graphql/generated/schemas'
import { getPetTypeRootCategoryKoreanText } from '@/utils/utilCategory'
import type { WatchQueryFetchPolicy } from '@apollo/client'

interface Props {
  petType: AdPetType
  selectedRootCategoryId?: string
  selectedSubCategoryId?: string
  rootCategorySlug?: string
  subCategorySlug?: string
  fetchPolicy?: WatchQueryFetchPolicy
}

/**
 * 1depth 최상위 카테고리 => 강아지, 고양이
 * 2depth 루트 카테고리 => 강아지 > 사료..., 고양이 > 사료...
 * 3depth 서브 카테고리 => 고양이 > 사료 > 키튼(~1세)...
 *
 * @param petType
 * @param selectedRootCategoryId
 * @param selectedSubCategoryId
 * @param rootCategorySlug
 * @param subCategorySlug
 */
const useCategoryContainerHook = ({ petType, rootCategorySlug, subCategorySlug, fetchPolicy }: Props) => {
  const { data } = useRootCategoriesQuery({
    fetchPolicy,
    variables: {
      filter: {
        isRootCategory: true,
        isShown: true,
      },
    },
    skip: !petType,
  })

  const rootCategories =
    (data?.categories?.edges
      .find((e) => e?.node?.name === getPetTypeRootCategoryKoreanText(petType))
      ?.node?.categoryChildren?.edges.map((e) => e?.node) as CategoryType[]) || []

  const rootCategory = rootCategories.find((c) => c?.slug === rootCategorySlug || c?.id === rootCategorySlug)

  const subCategories = rootCategory?.categoryChildren?.edges.map((e) => e?.node) || []

  const subCategory = subCategorySlug
    ? subCategories.find((c) => c?.slug === subCategorySlug || c?.id === subCategorySlug)
    : undefined

  return { rootCategories, rootCategory, subCategories, subCategory }
}

export default useCategoryContainerHook
